import { useTheme } from '@simplywallst/ui-core';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import Media from 'react-media';
import type { CompanyReportSection } from '../../useSection';
import DesktopSidebarWithSnowflake from '../DesktopSidebarWithSnowflake';

function NavigationDesktop({
  section,
  onSectionChange,
  keepSnowflakePinned,
}: {
  section: CompanyReportSection;
  onSectionChange?: (section: CompanyReportSection) => void;
  keepSnowflakePinned?: boolean;
}) {
  const theme = useTheme();
  const { isDesktop } = useUserAgent();

  return (
    <Media
      query={{ minWidth: theme.lgMinRaw }}
      defaultMatches={isDesktop}
      render={() => (
        <DesktopSidebarWithSnowflake
          keepSnowflakePinned={keepSnowflakePinned}
          selected={section}
          handleClick={(section) =>
            onSectionChange?.(section as CompanyReportSection)
          }
        />
      )}
    />
  );
}
export default NavigationDesktop;
